/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { get, post, del } from './base';
var URL = '/space';
export var GetAllBranchesAPI = function GetAllBranchesAPI() {
  return get("".concat(URL, "/branches/"));
};
export var GetBranchesAPI = function GetBranchesAPI(region) {
  return get("".concat(URL, "/branches/?region=").concat(region));
};
export var GetRegionsAPI = function GetRegionsAPI() {
  return get("".concat(URL, "/regions/"));
};
export var GetMyFavoriteBranchesAPI = function GetMyFavoriteBranchesAPI(query, config) {
  return query ? get("".concat(URL, "/my-favorite-branches/?lat=").concat(query.lat, "&lon=").concat(query.lng), config) : get("".concat(URL, "/my-favorite-branches/"), config);
};
export var GetNearMePublicSpaces = function GetNearMePublicSpaces(query, count, config) {
  return query ? get("".concat(URL, "/near-me/public-spaces/?lat=").concat(query.lat, "&lon=").concat(query.lng, "&count=").concat(count), config) : get("".concat(URL, "/near-me/public-spaces/?count=").concat(count), config);
};
export var GetNearMeMeetingRooms = function GetNearMeMeetingRooms(query, count, config) {
  return query ? get("".concat(URL, "/near-me/meeting-rooms/?lat=").concat(query.lat, "&lon=").concat(query.lng, "&count=").concat(count), config) : get("".concat(URL, "/near-me/meeting-rooms/?count=").concat(count), config);
};
export var GetNearMeRetails = function GetNearMeRetails(query, count, config) {
  return query ? get("".concat(URL, "/near-me/retails/?lat=").concat(query.lat, "&lon=").concat(query.lng, "&count=").concat(count), config) : get("".concat(URL, "/near-me/retails/?count=").concat(count), config);
};
export var GetFavoriteBranchesAPI = function GetFavoriteBranchesAPI(config) {
  return get("".concat(URL, "/favorite-branches/"), config);
};
export var PostFavoriteBranchesAPI = function PostFavoriteBranchesAPI(branches, config) {
  return post("".concat(URL, "/favorite-branches/"), branches, config);
};
export var GetBranchAPI = function GetBranchAPI(id) {
  return get("".concat(URL, "/branches/").concat(id, "/"));
};
export var GetSpaceOfficeAPI = function GetSpaceOfficeAPI() {
  return get("".concat(URL, "/offices/"));
};
export var GetAllRetailsAPI = function GetAllRetailsAPI() {
  return get("".concat(URL, "/retails/?page_size=50"));
};
export var GetRetailAPI = function GetRetailAPI(id) {
  return get("".concat(URL, "/retails/").concat(id, "/"));
};
export var GetMeetingRoom = function GetMeetingRoom(id) {
  return get("".concat(URL, "/meeting-rooms/").concat(id, "/"));
};
export var GetMeetingRooms = function GetMeetingRooms(id, config) {
  return get("".concat(URL, "/meeting-rooms/?floor__branch=").concat(id), config);
};
export var GetMeetingRoomReservations = function GetMeetingRoomReservations(id, config) {
  return get("".concat(URL, "/meeting-room/reservations/?meeting_room=").concat(id, "&page_size=1000"), config);
};
export var PostMeetingRoomReservations = function PostMeetingRoomReservations(data, config) {
  return post("".concat(URL, "/meeting-room/reservations/"), data, config);
};
export var GetMeetingRoomReservation = function GetMeetingRoomReservation(id, config) {
  return get("".concat(URL, "/meeting-room/reservations/").concat(id, "/"), config);
};
export var DeleteMeetingRoomReservation = function DeleteMeetingRoomReservation(id, config) {
  return del("".concat(URL, "/meeting-room/reservations/").concat(id, "/"), config);
};
export var GetMypageMeetingRoomReservations = function GetMypageMeetingRoomReservations(config) {
  return get("".concat(URL, "/mypage/meeting-room-reservations/"), config);
};
export var GetRemainingHour = function GetRemainingHour(config) {
  return get("".concat(URL, "/meeting-room/remaining-hour/"), config);
};